import { useQuery } from '@tanstack/react-query';

import { diseaseCodeApi } from '../api/disease-code.adapter';

export const diseaseCodeQueryKeys = {
  all: ['disease-code'] as const,
  groups: () => [...diseaseCodeQueryKeys.all, 'groups'] as const,
  codes: (groupId: number) =>
    [...diseaseCodeQueryKeys.all, 'codes', groupId] as const,
  refs: (codeId: number) =>
    [...diseaseCodeQueryKeys.all, 'refs', codeId] as const,
};

export function useDiseaseGroupsQuery() {
  return useQuery({
    queryKey: diseaseCodeQueryKeys.groups(),
    queryFn: () => diseaseCodeApi.listGroups(),
  });
}
